var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("View Downtime Report")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", small: "", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.printReport(_vm.downtimeReportId)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-printer")
                  ]),
                  _vm._v(" Print ")
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "white",
                    small: "",
                    text: "",
                    to: "/downtime-reports"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-arrow-left")
                  ]),
                  _vm._v(" Back ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Customer:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.report.customer?.name || "N/A"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Unit:")]),
                    _c("div", [_vm._v(_vm._s(_vm.report.unit_id || "N/A"))])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Subject:")]),
                    _c("div", [_vm._v(_vm._s(_vm.report.subject || "N/A"))])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Reported Issue:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.report.reported_issue || "N/A"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Description:")]),
                    _c("div", [_vm._v(_vm._s(_vm.report.description || "N/A"))])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Machine Type:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.report.machine_type?.name || "N/A"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Reported At:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatDate(_vm.report.reported_at)))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Date Start:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatDate(_vm.report.date_start)))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Date End:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatDate(_vm.report.date_end)))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Status Before:")]),
                    _c(
                      "div",
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "text-capitalize",
                            attrs: {
                              small: "",
                              color: _vm.statusColor(
                                _vm.report.list_status_before
                              ),
                              dark: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.report.list_status_before || "N/A") +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Status After:")]),
                    _c(
                      "div",
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "text-capitalize",
                            attrs: {
                              small: "",
                              color: _vm.statusColor(
                                _vm.report.list_status_after
                              ),
                              dark: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.report.list_status_after || "N/A") +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Project Status:")]),
                    _c(
                      "div",
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "text-capitalize",
                            attrs: {
                              small: "",
                              color: _vm.statusColor(_vm.report.status),
                              dark: ""
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.report.status || "N/A") + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("strong", [_vm._v("Error Code:")]),
                    _c("div", [_vm._v(_vm._s(_vm.report.error || "N/A"))])
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Purchase Needed:")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.report.purchase_needed ? "Yes" : "No"))
                    ])
                  ])
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4" }),
              _c(
                "h4",
                { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                [_vm._v("Inspection Findings")]
              ),
              _c(
                "v-list",
                { attrs: { dense: "", "two-line": "" } },
                _vm._l(_vm.findingsArray, function(finding, i) {
                  return _c(
                    "v-list-item",
                    { key: "f-" + i },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-checkbox-marked-circle")
                          ])
                        ],
                        1
                      ),
                      _c("v-list-item-content", [_vm._v(_vm._s(finding))])
                    ],
                    1
                  )
                }),
                1
              ),
              _c("v-divider", { staticClass: "my-4" }),
              _c(
                "h4",
                { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                [_vm._v("Actions")]
              ),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                _vm._l(_vm.report.actions, function(a, i) {
                  return _c(
                    "v-list-item",
                    { key: "a-" + i },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-wrench")
                          ])
                        ],
                        1
                      ),
                      _c("v-list-item-content", [_vm._v(_vm._s(a.action))])
                    ],
                    1
                  )
                }),
                1
              ),
              _c("v-divider", { staticClass: "my-4" }),
              _c(
                "h4",
                { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                [_vm._v("Recommendations")]
              ),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                _vm._l(_vm.recommendationsArray, function(rec, i) {
                  return _c(
                    "v-list-item",
                    { key: "r-" + i },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-lightbulb-on")
                          ])
                        ],
                        1
                      ),
                      _c("v-list-item-content", [_vm._v(_vm._s(rec))])
                    ],
                    1
                  )
                }),
                1
              ),
              _c("v-divider", { staticClass: "my-4" }),
              _c(
                "h4",
                { staticClass: "text-subtitle-1 font-weight-medium mb-2" },
                [_vm._v("Machine Components")]
              ),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                _vm._l(_vm.report.machine_components, function(comp, i) {
                  return _c(
                    "v-list-item",
                    { key: "c-" + i },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-cog")
                          ])
                        ],
                        1
                      ),
                      _c("v-list-item-content", [
                        _vm._v(
                          " " +
                            _vm._s(comp.name) +
                            " (" +
                            _vm._s(comp.type?.name) +
                            " - " +
                            _vm._s(comp.category?.name) +
                            ") "
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }